/* ========================================================================

 * DOM-based Routing

 * Based on http://goo.gl/EUTi53 by Paul Irish

 *

 * Only fires on body classes that match. If a body class contains a dash,

 * replace the dash with an underscore when adding it to the object below.

 *

 * .noConflict()

 * The routing is enclosed within an anonymous function so that you can

 * always reference jQuery with $, even when in .noConflict() mode.

 * ======================================================================== */

;(function ($) {
	var Sage = {
		// All pages

		common: {
			init: function () {
				// JavaScript to be fired on all pages
			},

			finalize: function () {
				// JavaScript to be fired on all pages, after page specific JS is fired
			},
		},

		// Home page

		home: {
			init: function () {
				// JavaScript to be fired on the home page
			},

			finalize: function () {
				// JavaScript to be fired on the home page, after the init JS
			},
		},

		// About us page, note the change from about-us to about_us.

		about_us: {
			init: function () {
				// JavaScript to be fired on the about us page
			},
		},
	}

	var UTIL = {
		fire: function (func, funcname, args) {
			var fire

			var namespace = Sage

			funcname = funcname === undefined ? 'init' : funcname

			fire = func !== ''

			fire = fire && namespace[func]

			fire = fire && typeof namespace[func][funcname] === 'function'

			if (fire) {
				namespace[func][funcname](args)
			}
		},

		loadEvents: function () {
			// Fire common init JS

			UTIL.fire('common')

			// Fire page-specific init JS, and then finalize JS

			$.each(
				document.body.className.replace(/-/g, '_').split(/\s+/),
				function (i, classnm) {
					UTIL.fire(classnm)

					UTIL.fire(classnm, 'finalize')
				}
			)

			// Fire common finalize JS

			UTIL.fire('common', 'finalize')
		},
	}

	// Load Events

	$(document).ready(UTIL.loadEvents)

	var windowWidth = $(window).innerWidth()

	var topOfWindow = $(window).scrollTop()

	$(window).resize(function () {
		windowWidth = $(window).innerWidth()

		topOfWindow = $(window).scrollTop()
	})

	//===== Header

	var headerEl = $('header.banner')

	var backToTopBtn = $('.back-to-top')

	headerPosition()

	footerPosition()

	$(window).scroll(function () {
		topOfWindow = $(window).scrollTop()

		headerPosition()

		footerPosition()

		headerParalax(windowWidth)
	})

	function headerPosition() {
		var topOfWindow = $(window).scrollTop()

		if (topOfWindow > 1) {
			headerEl.addClass('header-scroll')
		} else {
			headerEl.removeClass('header-scroll')
		}
	}

	function footerPosition() {
		var pageHeight = $('html, body').height()

		var positionBottom = $(window).scrollTop() + $(window).height()

		if (positionBottom > pageHeight - 20) {
			backToTopBtn.addClass('show-btn')
		} else {
			backToTopBtn.removeClass('show-btn')
		}
	}

	function headerParalax(windowWidth) {
		var topOfWindow = $(window).scrollTop()

		var headerContent = $('.page-header .content')

		var headerBg = $('.page-header .header-bg-block')

		var topPlus = topOfWindow / 7.5

		var topMinus = topOfWindow / 8

		if (windowWidth > 991) {
			topPlus = topOfWindow / 5.7
		}

		headerContent.css('top', topPlus)

		headerBg.css('top', -topMinus)
	}

	// Scroll to top btn

	backToTopBtn.on('click', function (e) {
		e.preventDefault()

		$('html, body').animate({scrollTop: 0}, 500)
	})

	// Achievements Counter Block

	var showCounter = false

	var countbox = '.achievements-block'

	if ($(countbox).is('div')) {
		showCounter = true
	}

	!(function (t) {
		t.extend(t.easing, {
			spincrementEasing: function (t, a, e, n, r) {
				return a === r ? e + n : n * (-Math.pow(2, (-10 * a) / r) + 1) + e
			},
		}),
			(t.fn.spincrement = function (a) {
				function e(t, a) {
					if (
						((t = t.toFixed(a)),
						a > 0 &&
							'.' !== r.decimalPoint &&
							(t = t.replace('.', r.decimalPoint)),
						r.thousandSeparator)
					)
						for (; o.test(t); )
							t = t.replace(o, '$1' + r.thousandSeparator + '$2')
					return t
				}
				var n = {
						from: 0,
						to: null,
						decimalPlaces: null,
						decimalPoint: '.',
						thousandSeparator: ',',
						duration: 1e3,
						leeway: 50,
						easing: 'spincrementEasing',
						fade: !0,
						complete: null,
					},
					r = t.extend(n, a),
					o = new RegExp(/^(-?[0-9]+)([0-9]{3})/)
				return this.each(function () {
					var a = t(this),
						n = r.from
					a.attr('data-from') && (n = parseFloat(a.attr('data-from')))
					var o
					if (a.attr('data-to')) o = parseFloat(a.attr('data-to'))
					else if (null !== r.to) o = r.to
					else {
						var i =
								t.inArray(r.thousandSeparator, [
									'\\',
									'^',
									'$',
									'*',
									'+',
									'?',
									'.',
								]) > -1
									? '\\' + r.thousandSeparator
									: r.thousandSeparator,
							l = new RegExp(i, 'g')
						o = parseFloat(a.text().replace(l, ''))
					}
					var c = r.duration
					r.leeway &&
						(c += Math.round(
							(r.duration * (2 * Math.random() - 1) * r.leeway) / 100
						))
					var s
					if (a.attr('data-dp')) s = parseInt(a.attr('data-dp'), 10)
					else if (null !== r.decimalPlaces) s = r.decimalPlaces
					else {
						var d = a.text().indexOf(r.decimalPoint)
						s = d > -1 ? a.text().length - (d + 1) : 0
					}
					a.css('counter', n),
						r.fade && a.css('opacity', 0),
						a.animate(
							{counter: o, opacity: 1},
							{
								easing: r.easing,
								duration: c,
								step: function (t) {
									a.html(e(t * o, s))
								},
								complete: function () {
									a.css('counter', null),
										a.html(e(o, s)),
										r.complete && r.complete(a)
								},
							}
						)
				})
			})
	})(jQuery)

	$(window).on('scroll load', function () {
		if (!showCounter) return false

		var countboxTop = $(countbox).offset().top

		var wHeight = $(window).height()

		if (topOfWindow > countboxTop - wHeight + 150) {
			CounterFnc()

			showCounter = false
		}
	})

	function CounterFnc() {
		$('.spincrement:eq(0)').spincrement({
			to: $('.spincrement:eq(0)').data('count-to'),

			thousandSeparator: ' ',

			duration: 700,
		})

		$('.spincrement:eq(1)').spincrement({
			to: $('.spincrement:eq(1)').data('count-to'),

			thousandSeparator: ' ',

			duration: 1100,
		})

		$('.spincrement:eq(2)').spincrement({
			to: $('.spincrement:eq(2)').data('count-to'),

			thousandSeparator: ' ',

			duration: 1500,
		})

		$('.spincrement:eq(3)').spincrement({
			to: $('.spincrement:eq(3)').data('count-to'),

			thousandSeparator: ' ',

			duration: 1900,
		})
	}

	// Dropdown menu

	var dropdownItem = $('.menu-item-has-children')

	dropDownFnc(windowWidth)

	$(window).resize(function () {
		dropDownFnc(windowWidth)

		if (windowWidth > 991) {
			dropdownItem.height(21).removeClass('mob-menu-open')
		} else {
			dropdownItem.height(23).removeClass('mob-menu-open')
		}
	})

	function dropDownFnc(windowWidth) {
		if (windowWidth > 991) {
			dropdownItem.mouseover(function () {
				var $this = $(this)

				var subMenu = $('.sub-menu')

				$this.addClass('visible')

				$this.find(subMenu).addClass('show-dropdown')
			})

			dropdownItem.mouseleave(function () {
				dropdownItem.removeClass('visible')

				var $this = $(this)

				var subMenu = $('.sub-menu')

				$this.find(subMenu).removeClass('show-dropdown')
			})
		} else {
			var dropdownItemMob = $('.menu-item-has-children a')

			dropdownItemMob.on('click', function (e) {
				if (e.offsetX > this.offsetWidth) {
					e.preventDefault()

					var checkHeight = 23

					var parent = $(e.target).closest('.menu-item-has-children'),
						parentHeight = $(parent).innerHeight()

					if (parentHeight > checkHeight) {
						dropdownItem.height(checkHeight).removeClass('mob-menu-open')
					} else {
						dropdownItem.height(checkHeight).removeClass('mob-menu-open')

						var subMenuHeight = $(parent).find('.sub-menu').innerHeight()

						$(parent)
							.height(checkHeight + subMenuHeight)
							.addClass('mob-menu-open')
					}
				}
			})
		}
	}

	// Testing Block (Block 3) Animation block

	function testBlockAnimation(topScrollTitle, topScrollItems) {
		var topOfWindow = $(window).scrollTop()

		if (topOfWindow > topScrollTitle) {
			titleBlockTitle.addClass('show-block')
		}

		if (topOfWindow > topScrollItems) {
			BlockItems.addClass('show-items')
		}
	}

	var testingBlock = $('.section.testing_block ')

	if (testingBlock.is('div')) {
		var titleBlockTitle = $('.section.testing_block .title-block')

		var BlockItems = $('.section.testing_block .testing-items')

		var titleOffset = titleBlockTitle.offset()

		var offsetTopStartAnimation = titleOffset.top - $(window).height() + 100

		var BlockOffset = BlockItems.offset()

		var offsetStartAnimationBlock = BlockOffset.top - $(window).height() + 170

		$(window).scroll(function () {
			testBlockAnimation(offsetTopStartAnimation, offsetStartAnimationBlock)
		})
	}

	// Testing Types (Block 4) Animation block

	function testTypesAnimation(topScrollItems) {
		var topOfWindow = $(window).scrollTop()

		if (topOfWindow > topScrollItems) {
			typesBlockItems.addClass('show-items')
		}
	}

	var testingTypesBlock = $('.section.testing_types ')

	if (testingTypesBlock.is('div')) {
		var typesBlockItems = $('.section.testing_types .testing-items')

		var typesBlockOffset = typesBlockItems.offset()

		var offsetStartScale = typesBlockOffset.top - $(window).height() + 220

		$(window).scroll(function () {
			testTypesAnimation(offsetStartScale)
		})
	}

	// Parallax Block (Block 5, Block 10 )

	var ParallaxSection = $('.section.parallax_block ')

	var ParallaxSectionComesImage = $(
		'.section.parallax_block .comes-up-img-wrap'
	).find('img')

	if (ParallaxSection.is('div')) {
		$(window).scroll(function () {
			ParallaxSection.each(function (index) {
				ParallaxBlockFunc(ParallaxSection[index])
			})
		})
	}

	function ParallaxBlockFunc(ParallaxSection) {
		var ParallaxContent = $(ParallaxSection).find($('.container ')),
			ParallaxBg = $('.parallax-bg'),
			ParallaxSectionOffset = $(ParallaxSection).offset()

		if (topOfWindow > ParallaxSectionOffset.top - $(window).height()) {
			var countParallaxOffset =
				(topOfWindow - (ParallaxSectionOffset.top - $(window).height())) / 11

			ParallaxContent.css('top', countParallaxOffset - 100)

			if (ParallaxBg.is('div')) {
				var countParallaxOffsetBg =
					(topOfWindow - (ParallaxSectionOffset.top - $(window).height())) / 17

				ParallaxBg.css('top', -(countParallaxOffsetBg + 10))
			}
		}
	}

	// Comes Up image

	function ComesImageCheck(ComesImageOsssetStart) {
		if (topOfWindow + $(window).height() / 1.5 > ComesImageOsssetStart) {
			ParallaxSectionComesImage.css('left', 0)
			ParallaxSectionComesImage.css('opacity', 1)
		} else {
			ParallaxSectionComesImage.css('left', 999)
			ParallaxSectionComesImage.css('opacity', 0)
		}
	}

	if (ParallaxSectionComesImage.is('img')) {
		var ComesImageOffset = ParallaxSectionComesImage.offset()

		var ComesImageOsssetStart = ComesImageOffset.top

		$(window).scroll(function () {
			ComesImageCheck(ComesImageOsssetStart)
		})
	}

	// Clutch Image

	var ClutchImageBlock = $('.section.clutch_block'),
		ClutchImage = $('.section.clutch_block .clutch-icon')

	function ClutchImageCheck(ClutchImageOsssetStart) {
		if (topOfWindow > ClutchImageOsssetStart) {
			ClutchImage.addClass('show-clutch')
		}
	}

	if (ClutchImageBlock.is('div')) {
		var ClutchImageOffset = ClutchImage.offset()

		var ClutchImageOsssetStart =
			ClutchImageOffset.top - $(window).height() + 150

		$(window).scroll(function () {
			ClutchImageCheck(ClutchImageOsssetStart)
		})
	}

	var reviewsIcons = $('.clutch-icon > a')
	// console.log(reviewsIcons)

	if (reviewsIcons.length) {
		reviewsIcons.each(function () {
			$(this).hide()
		})

		var showIconTime = 500
		var interval = showIconTime * reviewsIcons.length
		// for (var i = 0; i < reviewsIcons.length; i++) {

		function anim_loop(index) {
			reviewsIcons.eq(index).fadeIn(1000, function () {
				var $self = $(this)
				setTimeout(function () {
					$self.fadeOut(1000)
					anim_loop((index + 1) % reviewsIcons.length)
				}, 3000)
			})
		}

		anim_loop(0)

		// 	reviewsIcons.each(function (i) {

		// 		$(this)
		// 			.show('slow')
		// 			.delay(showIconTime)
		// 			.hide('slow')
		// 			.delay(showIconTime * i)
		// 	})
		// }, interval)
		// }
	}

	//===== Coming Events (Meet Us) section slider

	var EventsSwiper = new Swiper('.events-slider .slider-container', {
		// Optional parameters

		direction: 'horizontal',

		slidesPerView: 3,

		slidesPerColumn: 1,

		slidesOffsetAfter: 0,

		spaceBetween: 30,

		loop: false,

		roundLengths: true,

		speed: 700,

		autoplay: false,

		navigation: {
			nextEl: '.events-controls .swiper-button-next',

			prevEl: '.events-controls .swiper-button-prev',
		},

		breakpoints: {
			767: {
				slidesPerView: 1,
			},

			991: {
				slidesPerView: 2,
			},
		},
	})

	//===== RecentPosts slider

	var RecentPostsSwiper = new Swiper('.recent_posts-slider .slider-container', {
		// Optional parameters

		direction: 'horizontal',

		slidesPerView: 3,

		slidesPerColumn: 1,

		slidesOffsetAfter: 0,

		spaceBetween: 30,

		loop: false,

		roundLengths: true,

		speed: 700,

		autoplay: false,

		navigation: {
			nextEl: '.recent_posts-controls .swiper-button-next',

			prevEl: '.recent_posts-controls .swiper-button-prev',
		},

		breakpoints: {
			767: {
				slidesPerView: 1,
			},

			991: {
				slidesPerView: 2,
			},
		},
	})

	//===== Testimonials section slider

	if ($('.section.testimonials').is('div')) {
		var stepsBulletsMas = []

		$('.client_image_url').each(function () {
			stepsBulletsMas.push($(this).html())
		})

		var TestimonialsSwiper = new Swiper(
			'.testimonials-slider .swiper-container',
			{
				// Optional parameters

				direction: 'horizontal',

				slidesPerView: 1,

				slidesPerColumn: 1,

				slidesOffsetAfter: 0,

				spaceBetween: 0,

				loop: false,

				roundLengths: true,

				speed: 700,

				autoplay: {
					delay: 4000,
				},

				navigation: {
					nextEl: '.testimonials-controls .swiper-button-next',

					prevEl: '.testimonials-controls .swiper-button-prev',
				},

				pagination: {
					el: '.testimonials-pagination',

					type: 'bullets',

					bulletElement: 'span',

					clickable: true,

					renderBullet: function (index, className) {
						return (
							'<span class="' +
							className +
							'" style="background: url(' +
							stepsBulletsMas[index] +
							' ) center center no-repeat"></span>'
						)
					},
				},
			}
		)
	}

	//filter case studies
	$('#filter').on('change', function () {
		var filter = $('#filter')
		$.ajax({
			url: filter.attr('action'),
			data: filter.serialize(), // form data
			type: filter.attr('method'), // POST
			beforeSend: function (xhr) {
				filter.find('.lds-ring').show() // changing the button label
			},
			success: function (data) {
				filter.find('.lds-ring').hide() // changing the button label back
				$('#response').html(data) // insert data
			},
		})
		return false
	})
	$('#job-filter').on('change', function () {
		var filter = $('#job-filter')
		$.ajax({
			url: filter.attr('action'),
			data: filter.serialize(), // form data
			type: filter.attr('method'), // POST
			beforeSend: function (xhr) {
				filter.find('.lds-ring').show() // changing the button label
			},
			success: function (data) {
				filter.find('.lds-ring').hide() // changing the button label back
				$('#job-content').html(data) // insert data
			},
		})
		return false
	})

	$('div.attach-cv input.wpcf7-form-control.wpcf7-file').on(
		'change',
		function () {
			var filename = document.querySelector(
				'input.wpcf7-form-control.wpcf7-file'
			).files[0].name
			filename = filename.split('').slice(0, 6).join('')
			$('.attach-label').text(filename + '...')
		}
	)

	$('.kb-subcategory > a, .kb-tag > a').on('click', function (e) {
		e.preventDefault()
		var link = $(this).attr('href')
		window.history.pushState({page: 'another'}, 'another page', link)

		var text = $(this).text()
		$('span.bread').html(
			'<i class="fa fa-angle-right" aria-hidden="true"></i>' + text
		)

		$('.kb-subcategory').each(function () {
			$(this).removeClass('kb-sub-active')
		})
		$(this).parent('.kb-subcategory').addClass('kb-sub-active')

		var taxonomy = $(this).data('taxonomy')
		var cat_id = $(this).data('cat_id')

		var filter = $('#kbfilter')
		filter.find('[name="taxonomy"]').val(taxonomy)
		filter.find('[name="cat_id"]').val(cat_id)
		filter = $('#kbfilter')

		var container = $('#kb-main')

		$.ajax({
			url: filter.attr('action'),
			data: filter.serialize(), // form data
			type: filter.attr('method'), // POST
			beforeSend: function (xhr) {
				$('.kb-loader').show()
				container.html('')
			},
			success: function (data) {
				$('.kb-loader').hide()
				container.html(data)
				if ($('a.page-numbers').length) {
					$('a.page-numbers').each(function () {
						var link = $(this)
							.attr('href')
							.replace('/wp-admin/admin-ajax.php', window.location.pathname)
						$(this).attr('href', link)
					})
				}
			},
			error: function () {
				$('.kb-loader').hide()
				container.html(
					"<div style='color: black;font-size: 20px;padding: 10px 20px;border: solid 2px red;border-radius: 10px;'>Something goes wrong... Try to refresh the page.</div>"
				)
			},
		})
		return false
	})

	// setTimeout(function () {
	$(window).load(function () {
		var $container = $('.masonry')
		$container.masonry({
			columnWidth: '.masonry-item',
			itemSelector: '.masonry-item',
		})
		// }, 1000)
	})
})(jQuery) // Fully reference jQuery after this point.
